import { render, staticRenderFns } from "./BackgroundDesign.vue?vue&type=template&id=e299b94c&scoped=true&"
import script from "./BackgroundDesign.vue?vue&type=script&lang=js&"
export * from "./BackgroundDesign.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundDesign.vue?vue&type=style&index=0&id=e299b94c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e299b94c",
  null
  
)

export default component.exports